<template>
  <div class="page-header md-blue-bg">
    <div
      class="md2018033001lty"
      style="position: fixed;z-index: 999;width: 100%;top: 0;"
    >
      <div class="container">
        <div class="logo-box pull-left" style="display: flex;">
          <div style="margin-top: 17px;">
            <a
              class="logo"
              style="left: 0;top:16px;font-weight: bold;font-size: 25px;color: #ffffff"
            >
              职业技能等级培训平台
            </a>
          </div>
          <div>
            <ul
              class="slide-nav pull-left clearfix manager-nav"
              id="js_slide_nav2"
            >
              <li
                v-for="(item, index) in lilist"
                :key="index"
                @click="leftBeginAffirm(index)"
              >
                <router-link
                  :to="item.url"
                  style="display: inline-block;width: 100%;color: #777;cursor: pointer;"
                >
                  <a
                    data-title="eLea"
                    :class="item.state == 2 ? 'active' : 'lose'"
                    >{{ item.name }}</a
                  >
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="login-area pull-right " id="login_statelty">
          <div class="md-2018040202-lty">
            <div class="drop-menu" id="js_init_dropmenu">
              <el-dropdown @command="handleCommand">
                <div class="md-2018040801-lty" style="margin-top: -5px;">
                  <div style="cursor: pointer;">
                    <img
                      class="js-headpic-xxw"
                      id="tobbar_userimg"
                      src="../../../static/img/head.svg"
                    />
                  </div>

                  <div
                    style="color: white;position: absolute;
                                    right: -75px;
                                    top: 3px;cursor: pointer;"
                  >
                    {{ this.$storage.get("declareUser").userName }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </div>
                </div>

                <ul class="drop-menu-list bgcolor-fff el-dropdown-link">
                  <el-dropdown-menu
                    slot="dropdown"
                    style="position: fixed;left: 1400px;"
                  >
                    <el-dropdown-item command="a">我的课程</el-dropdown-item>
                    <el-dropdown-item command="b">培训计划</el-dropdown-item>
                    <el-dropdown-item command="c">我的账户</el-dropdown-item>
                    <el-dropdown-item command="d">账号设置</el-dropdown-item>
                  </el-dropdown-menu>
                </ul>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view
      style="position: relative;top:70px"
      class="site-content"
      ref="target-name"
    ></router-view>
    <div class="page-footer" style="position: relative;top:70px">
      <div class="container">
        <div class="md2018040301lty clearfix">
          <div class="bt-fr clearfix pull-right"></div>
          <div class="bt-lf pull-left">
            <div class="copyright">
              Copyright © 山西众创网络科技有限公司版权所有
            </div>
          </div>
          <div class="bt-line"></div>
        </div>
      </div>
    </div>
    <el-backtop> </el-backtop>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  name: "app",
  components: {},
  data() {
    return {
      lilist: [
        { name: "首页", state: 2, url: "/trainHomePage" },
        // { name: '学习咨询', state: 1, url: '/learningConsultation' },
        { name: "课程中心", state: 1, url: "/courseCenter/" + undefined },
        //  { name: '在岗培训', state: 1, url: '/trainingPlan' },
        // { name: '培训计划', state: 1, url: '/trainingPlan' },
        { name: "课程直播", state: 1, url: "/liveClassroom" },
        { name: "试题练习", state: 1, url: "/exerciseHomePage" },
        { name: "个人中心", state: 1, url: "/personalCenter" }
      ]
    };
  },
  created() {
    //console.log("+++====" + JSON.stringify(this.$storage.get("declareUser")));

    this.leftBeginAffirm(0);
  },
  mounted() {},
  methods: {
    cut(index) {
      this.$refs["target-name"].Cut(
        this.$refs["target-name"].list[index],
        index
      );
    },
    handleCommand(command) {
      if (command === "a") {
        //我的课程
        this.$router.push({ path: "/mySelfBuyCourse" });
        // this.cut(0);
      } else if (command === "b") {
        //培训计划
        this.$router.push({ path: "/trainPlanPersonal" });
        // this.cut(1);
      } else if (command === "c") {
        //账号设置
        this.$router.push({ path: "/myAccount" });
        // this.cut(2);
      } else if (command === "d") {
        //退出登录
        this.$router.push({ path: "/accountSet" });
        // this.cut(3);
      }
    },
    leftBeginAffirm(index) {
      this.lilist.forEach(element => {
        if (element.state == 2) {
          element.state = 1;
        }
      });
      this.lilist[index].state = 2;
    }
  }
};
</script>

<style scoped>
.el-popper[x-placement^="bottom"] {
  margin-top: 15px;
  left: 1325px !important;
}
.md2018040301lty .bt-lf {
  padding-top: 66px;
}

.md2018040301lty .bt-line {
  width: 100%;
  height: 1px;
  background: #3d3e3f;
}

.md2018040301lty .bt-lf .copyright {
  color: #666;
  margin-left: -4px;
}

.md2018040301lty .bt-fr {
  padding-top: 50px;
}

.md2018040301lty .bt-fr {
  margin-bottom: 23px;
}

.md2018040301lty {
  height: 197px;
}

.page-footer {
  background: #282c30;
}

.md-2018040801-lty img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.manager-nav li a {
  display: block;
  height: 40px;
}

.manager-nav .active {
  color: #f08326 !important;
  border-bottom: 2px solid #f08326 !important;
}

.manager-nav .lose {
  color: white !important;
}

.md2018033001lty .slide-nav > li > a {
  color: #161616;
  font-size: 16px;
}

.md-blue-bg .md2018033001lty .slide-nav > li > a {
  color: #fff;
}

.page-header,
.page-con,
.page-body,
.page-footer {
  min-width: 1200px;
}

.md-blue-bg .md2018033001lty {
  background: #002856;
  box-shadow: 0 0 20px 10px rgb(79 141 254 / 20%);
}

.md2018033001lty {
  height: 70px;
  position: relative;
  background: #fff;
  box-shadow: 0 0 20px 10px rgb(221 221 221 / 50%);
  z-index: 100;
  min-width: 1200px;
}

.md2018033001lty .container {
  position: relative;
}

.container {
  clear: both;
  margin: 0 auto;
  text-align: left;
  width: 1200px;
}

.pull-left {
  float: left;
}

.md2018033001lty .login-area {
  height: 52px;
  margin: 20px 0 0 20px;
}

.pull-right {
  float: right;
}

.pull-left {
  float: left;
}

.md2018033001lty .slide-nav {
  margin: 24px 0 0 30px;
}

.md2018033001lty .slide-nav > li {
  float: left;
  padding: 0 20px;
}

.page-header.md-blue-bg .md-2018040801-lty {
  border-color: #fff;
}

.md-2018040801-lty {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 2px solid #4b95ff;
}
</style>



// WEBPACK FOOTER //
// src/components/train/train.vue